import { CircleAlert } from 'lucide-react'
import './styles.scss'

interface ModalProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
}

export const WarningEmptyUploadModal = ({
  isOpen,
  onClose,
  onConfirm,
}: ModalProps) => {
  if (!isOpen) return null

  return (
    <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
      <div className={`modal ${isOpen ? 'open' : ''}`}>
        <div className="content-info">
          <CircleAlert className="info-icon" size={70} />

          <p>
            Para receber sugestões de cores para o tema, você deve fazer o
            upload da logo.
          </p>
        </div>

        <div className="container-actions">
          <button className="close" onClick={onClose}>
            Fechar
          </button>
          <button onClick={onConfirm}>Continuar sem upload</button>
        </div>
      </div>
    </div>
  )
}
